import { Model as BaseModel } from 'vue-api-query';

export default class Model extends BaseModel {
  baseURL() {
    return 'admin';
  }

  // request is converted to FormData, because axios sends files only with FormData
  // Rewriting put method, because PHP doesn't accept multipart form-data in put request
  request(config) {
    const formDataConfig = Object.assign({}, config, {
      data: this.convertModelToFormData(config.data),
    });
    return this.$http.request(formDataConfig);
  }

  convertModelToFormData(model, form, namespace = '') {
    let formData = form || new FormData();

    if (namespace && form && typeof model === 'string') {
      formData.append(namespace, model);
      return formData;
    }

    for (let propertyName in model) {
      if (!model.hasOwnProperty(propertyName) || (!model[propertyName] && typeof model[propertyName] !== 'number')) {
        formData.append(propertyName, '');
        continue;
      }
      let formKey = namespace ? `${namespace}[${propertyName}]` : propertyName;
      if (model[propertyName] instanceof Date) formData.append(formKey, model[propertyName].toISOString());
      else if (model[propertyName] instanceof Array) {
        model[propertyName].forEach((element, index) => {
          const tempFormKey = `${formKey}[${index}]`;
          this.convertModelToFormData(element, formData, tempFormKey);
        });
      } else if (typeof model[propertyName] === 'object' && !(model[propertyName] instanceof File)) {
        this.convertModelToFormData(model[propertyName], formData, formKey);
      } else if (model[propertyName] instanceof File) {
        formData.append(formKey, model[propertyName], model[propertyName].name);
      } else {
        formData.append(formKey, model[propertyName].toString());
      }
    }

    if (typeof model === 'number' && form && namespace) {
      formData.append(namespace, model.toString());
    }

    return formData;
  }
}
